import React from "react";
import { spring, useCurrentFrame, useVideoConfig, interpolate } from "remotion";
import { WordTimestamp } from "../../types";

export const KineticTypeCaptions: React.FC<{
  subtitles: WordTimestamp[];
}> = ({ subtitles }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const currentMs = (frame / fps) * 1000;
  const currentWordIndex = subtitles.findIndex(
    (s) => currentMs >= s.startMs && currentMs < s.endMs
  );

  if (currentWordIndex === -1) return null;

  const currentWord = subtitles[currentWordIndex];

  // High energy scaling effect for current word
  const wordSpring = spring({
    frame: frame - (currentWord.startMs * fps) / 1000,
    fps,
    config: { stiffness: 200, damping: 12, mass: 0.5 },
  });

  return (
    <div
      style={{
        position: "absolute",
        bottom: "120px",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        pointerEvents: "none",
        zIndex: 100,
      }}
    >
      <div
        style={{
          background: "rgba(5, 8, 20, 0.9)",
          padding: "16px 40px",
          borderRadius: "24px",
          border: "2px solid #22D3EE",
          boxShadow: "0 0 40px rgba(34, 211, 238, 0.3)",
          transform: `scale(${interpolate(wordSpring, [0, 1], [0.8, 1])}) translateY(${interpolate(wordSpring, [0, 1], [20, 0])}px)`,
        }}
      >
        <span
          style={{
            fontFamily: "Outfit, sans-serif",
            fontSize: "48px",
            fontWeight: 900,
            color: "#BEF264",
            textTransform: "uppercase",
            letterSpacing: "2px",
            textShadow: "0 0 20px rgba(190, 242, 100, 0.5)",
          }}
        >
          {currentWord.word}
        </span>
      </div>
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
